import React from 'react';
import './privacy-link.scss';

const PrivacyLink = () => {
  return (
    <div className="privacy-link"><a href="/policies">Privacy</a></div>
  )
}

export default PrivacyLink